<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="区域" prop="orgName">
              <el-input
                v-model="searchForm.orgName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="cusName">
              <el-input
                v-model="searchForm.cusName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店" prop="storeName">
              <el-input
                v-model="searchForm.storeName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="职员" prop="staffName">
              <el-input
                v-model="searchForm.staffName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否离职" prop="online">
              <el-select v-model="searchForm.online" clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否认证" prop="authentication">
              <el-select v-model="searchForm.authentication" clearable @change="onSearch">
                <el-option v-for="item in authentication"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经销商经营状态" prop="cusStatus">
              <el-select v-model="searchForm.cusStatus" clearable @change="onSearch">
                <el-option v-for="item in businessStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排除免费报名" prop="freeActivity">
              <el-select v-model="searchForm.freeActivity" clearable @change="onSearch">
                <el-option v-for="item in signUp"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="截止时间" prop="updatedTime">
               <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">
            导出
          </el-button>
          <el-button type="primary" size="small" @click="exportListStore">
            区域拉新导出
          </el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="orgName" label="区域" min-width="160" align="center"></el-table-column>
          <el-table-column prop="cusName" label="经销商" min-width="200" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cusStatus" label="经销商经营状态" width="120" align="center"></el-table-column>
          <el-table-column prop="storeName" label="门店" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="staffName" label="职员" align="center" width="150"></el-table-column>
          <el-table-column prop="authenticationString" label="是否认证" width="100" align="center"></el-table-column>
          <el-table-column prop="onlineString" label="是否离职" align="center" width="100"></el-table-column>
          <el-table-column prop="browseNumber" label="浏览次数" align="center" width="140"></el-table-column>
          <el-table-column prop="pullNew" label="拉新人数" align="center" width="140"></el-table-column>
          <el-table-column prop="joinNum" label="报名数(不含退款)" align="center" width="140"></el-table-column>
          <el-table-column prop="returnNum" label="退款数" align="center" width="140"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <q-dialog
      :visible="isStorePop"
      title="数据导出"
      width="400px"
      :innerScroll="false"
      :contentLoading="loading"
      @close="close"
      @cancel="close"
      @confirm="onConfirm"
    >
      <div class="center">
        <span>导出时间</span>
        <el-date-picker
          class="date-input"
          size="small"
          v-model="storeDate"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="-"
          start-placeholder="起始时间"
          end-placeholder="截至时间"
        >
        </el-date-picker>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from "moment"
export default {
  name: "dataLachine",
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      searchForm: {
        orgName: "",
        cusName: "",
        storeName: "",
        staffName: "",
        startTime: "",
        endTime: "",
        online: 0,
        authentication: "",
        cusStatus: "",
        freeActivity: ""
      },
      panelData: {},
      statusOptions: [ 
        {value: '', label: '全部'},
        {value: 0, label: '否'},
        {value: 1, label: '是'},
      ],
      authentication: [ 
        {value: '', label: '全部'},
        {value: 1, label: '是'},
        {value: 0, label: '否'},
      ],
      businessStatus: [ 
        {value: '', label: '全部'},
        {value: 1, label: '正常营业'},
        {value: 2, label: '预停业'},
        {value: 3, label: '已停业'},
        {value: 4, label: '预营业'},
        {value: 5, label: '未开业停用'},
        {value: 6, label: '经营异常'},
      ],
      signUp: [
        {value: '', label: '全部'},
        {value: 1, label: '是'},
        {value: 0, label: '否'},
      ],

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {
        online: 0,
      },
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      isStorePop: false,
      storeDate: [],
      modifyData: null,
    };
  },
  methods: {
    init() {
      this.onSearch();
      this.getOrgBoardInfo();
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo().then((res) => {
        this.panelData = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .staffPullReportPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportListStore(type) {
      this.isStorePop = true
    },
    close() {
      this.isStorePop = false
      this.storeDate = []
    },
    onConfirm() {
      if (!this.storeDate.length) {
        this.$message.error("请选择导出时间");
        return
      }else {
        this.customColumnExport()
      }
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "manageList",
          params: row,
        })
      } else if (actionType == 1) {
        let params = {
          ...this.filterParam,
        };
        this.$api.common.doExport("staffPullReportPageList", params).then(() => {
          this.$message.success("导出操作成功，请前往导出记录查看详情");
        });
      }
    },
    generateDateStrings() {
      const startDate = new Date(moment(this.storeDate[0]).format('YYYY-MM-DD'));
      const endDate = new Date(moment(this.storeDate[1]).format('YYYY-MM-DD')); 
      let currentDate = new Date(startDate);
      const dateList = [
        {
          columnName: '区域名称',
          fieldName: 'orgName',
          fieldType: ''
        }
      ];
      while (currentDate <= endDate) {
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          dateList.push(
            {
              columnName: year + '年' + month + '月' + day + '拉新数据',
              fieldName: year + '-' + month + '-' + day,
              fieldType: "",
            },
          );
          currentDate.setDate(currentDate.getDate() + 1);
      }
      return dateList;
    },

    customColumnExport() {
      let columnDTOs  = this.generateDateStrings()
      let params = {
        columnDTOs: columnDTOs,
        taskDTO: {
          appCode: "activity-pc-manage-api",
          reportName: "staffPullReportExport",
          paramMap: {
            orgName: this.searchForm.orgName,
            startTime: this.storeDate[0],
            endTime: this.storeDate[1]
          },
        },
      };
      this.$api.common.customColumnExport(params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important

.center {
  height: 10vh;
  text-align: center
  margin-top: 20px;
  span {
    margin-right: 20px;
  }
}
</style>
